import * as React from 'react';
import classnames from 'classnames';

import { sanitizeGenericHtml } from 'utils/sanitize';

import './action-message.scss';

type Props = {
  children?: React.ReactNode,
  message: string,
  size: 'normal' | 'small'
};

class ActionMessage extends React.PureComponent<Props> {
  static defaultProps = {
    size: 'normal'
  };

  render() {
    const { children, message, size } = this.props;

    const classes = classnames({
      'action-message': true,
      [`action-message--${size}`]: size
    });

    return (
      <section className={classes}>
        {
          message && (
            <span
              className="action-message__message"
              dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(message) }}
            />
          )
        }
        {
          children && (
            <div className="action-message__action">
              <span>{children}</span>
            </div>
          )
        }
      </section>
    );
  }
}

export default ActionMessage;
